var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityGrid } from './entity-grid';
import { EntityValuePillList } from './entity-value-pill-list';
import { OrganisationMarketMapGrid } from './organisation-market-map-grid';
import { flatten } from 'lodash';
import { useEntityTypeValueTargets } from '../hooks/use-entity-type-value-targets';
import { usePageEntity } from '../hooks/use-page-entity';
import { EntityLinkValue } from './entity-link-value';
import { EntityValue } from './entity-value';
var cls = classNames('entity-items');
export var EntityItemsDefaultProps = {
  variant: 'List',
  disableLinks: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var EntityValuePillsStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n   \n  "], ["\n   \n  "])))
});
var EntityValueStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var EntityGridStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ThumbnailCardGridStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ListStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    gap: ", ";\n  "])), theme.UNIT(5), theme.UNIT(5))
});
var GridStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(5)),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: flex-start;\n  "], ["\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: flex-start;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'EntityItems',
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  EntityLinkValue: styled(EntityLinkValue)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), EntityValueStyles),
  EntityValue: styled(EntityValue)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), EntityValueStyles),
  EntityValuePills: styled(EntityValuePillList)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), EntityValuePillsStyles),
  CardGrid: styled(EntityGrid)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), EntityGridStyles),
  ThumbnailCardGrid: styled(OrganisationMarketMapGrid)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ThumbnailCardGridStyles),
  List: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  Grid: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), GridStyles)
};
export var EntityItems = function (props) {
  var componentProps = useComponentProps(My.NAME, EntityItemsDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    items = componentProps.items,
    variant = componentProps.variant,
    disableLinks = componentProps.disableLinks,
    label = componentProps.label;
  var valueTargetDerivers = useEntityTypeValueTargets();
  var sourceEntity = usePageEntity();
  var finalItems = [];
  if (variant === 'ValuePillList') {
    finalItems = flatten(items.map(function (item) {
      var typeName = entityTypeNameFor(item);
      var _a = (valueTargetDerivers[typeName] || valueTargetDerivers.Entity)(item, sourceEntity) || {},
        targets = _a.targets,
        source = _a.source;
      return (targets || []).map(function (target) {
        return __assign(__assign({}, target), {
          typeLabel: source === null || source === void 0 ? void 0 : source.name
        });
      });
    }));
  }
  ;
  if (variant === 'List' || variant === 'ValueGrid') {
    finalItems = flatten(items.map(function (item) {
      var typeName = entityTypeNameFor(item);
      var _a = (valueTargetDerivers[typeName] || valueTargetDerivers.Entity)(item, sourceEntity) || {},
        targets = _a.targets,
        source = _a.source;
      return (targets || []).map(function (target) {
        return __assign(__assign({}, target), {
          subtitle: source === null || source === void 0 ? void 0 : source.name,
          typeLabel: null
        });
      });
    }));
  }
  ;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, variant === 'ValuePillList' && React.createElement(My.EntityValuePills, {
    items: finalItems,
    variant: 'small',
    showLabel: true,
    showTitleLabel: false
  }), variant === 'ValueGrid' && React.createElement(My.Grid, null, finalItems.map(function (item) {
    return !!item.path && !disableLinks ? React.createElement(My.EntityLinkValue, {
      key: item.id,
      entity: item,
      subtitle: item === null || item === void 0 ? void 0 : item.subtitle
    }) : React.createElement(My.EntityValue, {
      key: item.id,
      entity: item,
      subtitle: item === null || item === void 0 ? void 0 : item.subtitle
    });
  })), variant === 'List' && React.createElement(My.List, null, finalItems.map(function (item) {
    return !!item.path && !disableLinks ? React.createElement(My.EntityLinkValue, {
      key: item.id,
      showLabel: false,
      entity: item,
      subtitle: item === null || item === void 0 ? void 0 : item.subtitle
    }) : React.createElement(My.EntityValue, {
      key: item.id,
      showLabel: false,
      entity: item,
      subtitle: item === null || item === void 0 ? void 0 : item.subtitle
    });
  })), variant === 'CardGrid' && React.createElement(My.CardGrid, {
    items: items,
    spacing: 4
  }), variant === 'ThumbnailCardGrid' && React.createElement(My.ThumbnailCardGrid, {
    items: items.slice(0, 5),
    spacing: 2,
    hasBorder: true
  }));
};
EntityItems.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;